import { render, staticRenderFns } from "./Idea3.vue?vue&type=template&id=eb48dfe6"
import script from "./Idea3.vue?vue&type=script&lang=js"
export * from "./Idea3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports